/**
 * Collapse catalogue duplicates that share the same title (case/spacing insensitive).
 * Prefers the entry with a price, image, and rating when multiple exist.
 */
export function dedupeBooksByTitle(books = []) {
  if (!Array.isArray(books) || books.length === 0) return [];

  const score = (book) => {
    let s = 0;
    if (book?.image) s += 2;
    if (book?.price != null && book.price !== "") s += 2;
    if (book?.description) s += 1;
    if (book?.rating) s += 1;
    return s;
  };

  const byTitle = new Map();

  for (const book of books) {
    const key = (book?.title || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
    if (!key) continue;

    const existing = byTitle.get(key);
    if (!existing || score(book) > score(existing)) {
      byTitle.set(key, book);
    }
  }

  return Array.from(byTitle.values());
}
